import React, { useEffect, useState } from 'react';
import ReactPlaceholder from 'react-placeholder';


const HomeInsurance = (props) => {
  const logos = [
    "/insurance/aetna.webp",
    "/insurance/bcbs.webp",
    "/insurance/cigna.webp",
    "/insurance/humana.webp",
    "/insurance/united.webp",
  ];

  const [ready, setReady] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setReady(true)
    }, 1000);
  })

  return (
    <>
      <div className="home-logo-main section-gap">
        <div className="container">
          <span className="home-as-seen mt-3 mb-5 ">
            <ReactPlaceholder showLoadingAnimation ready={ready} type="rect" style={{ height: "10px", width: "35%" }}>
              Your insurance can cover most costs
            </ReactPlaceholder>
          </span>
          <div className="container mt-3">
            <div className="home-logos">
              <div className="home-logos-images">
                {
                  logos.map((element, key) => (
                    <div key={key} className={`img-logo-div img-logo-${key}`}>
                      <ReactPlaceholder showLoadingAnimation ready={ready} type="rect" style={{ height: "60px", width: "150px" }}>
                        <img src={element} key={key} />
                      </ReactPlaceholder>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
      </div></>
  );
};
export default HomeInsurance;

